import React, { useState } from 'react';
import { FadeInUp } from './FadeInUp';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  question: '¿Necesito comprar ingredientes especiales?',
  answer: 'No. Todo lo que necesitas lo encuentras en Walmart, Target o cualquier supermercado. Son ingredientes comunes que probablemente ya tienes en tu cocina.'
}, {
  question: '¿Funciona si tengo más de 40 años?',
  answer: 'Sí. De hecho, muchas de nuestras clientas tienen entre 35 y 55 años. El método está diseñado para el cuerpo de la mujer latina real, no para modelos de 20 años.'
}, {
  question: '¿Es una dieta restrictiva?',
  answer: 'No. No vas a pasar hambre ni a dejar de comer lo que te gusta. Es un plan de comidas simples y equilibradas que ayudan a tu cuerpo a desinflamarse naturalmente.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tienes 7 días completos para probarlo. Si no estás satisfecha, te devolvemos el 100% de tu dinero. Sin preguntas, sin complicaciones.'
}, {
  question: '¿Cómo recibo el producto?',
  answer: 'Es un producto digital (PDF). Inmediatamente después de tu compra recibes un enlace de descarga. Lo puedes ver en tu teléfono, tablet o computadora.'
}];
export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 bg-white" data-id="element-227">
      <div className="max-w-3xl mx-auto" data-id="element-228">
        <FadeInUp data-id="element-229">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-12 text-center text-deep-green" data-id="element-230">
            Preguntas Frecuentes
          </h2>
        </FadeInUp>

        <div className="space-y-4" data-id="element-231">
          {FAQS.map((faq, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-232">
              <div className="border border-black/5 rounded-2xl overflow-hidden bg-cream/50" data-id="element-233">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-234">
                  <span className="font-bold text-deep-green pr-4" data-id="element-235">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="shrink-0 text-sage" data-id="element-236">
                    <ChevronDown className="w-5 h-5" data-id="element-237" />
                  </motion.div>
                </button>
                <AnimatePresence initial={false} data-id="element-238">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-239">
                      <div className="px-6 pb-5 text-charcoal/70 leading-relaxed" data-id="element-240">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeInUp>)}
        </div>
      </div>
    </section>;
}